// extracted by mini-css-extract-plugin
export var fullwidth = "NavigationButtons-module--fullwidth--32055";
export var linkActive = "NavigationButtons-module--link-active--cfd60";
export var links = "NavigationButtons-module--links--e4f86";
export var linksWrapper = "NavigationButtons-module--links-wrapper--62f90";